import VueRouter from "vue-router";
import MediaGalleryLogin from "./views/MediaGalleryLogin.vue";
import MediaGalleryTermAndConditions from "./views/MediaGalleryTermAndConditions.vue";
import MediaGallerySearchView from "./views/MediaGallerySearchView.vue";
import MediaGalleryCollectionView from "./views/MediaGalleryCollectionView.vue";
import {MediaGalleryStateModeEnum} from "./store/MediaGalleryStateType";

export enum ROUTES {
    LOGIN = 'login',
    TERMS_AND_CONDITIONS = 'terms-and-conditions',
    SEARCH = 'media-search',
    COLLECTION = 'collection'
}

const router = new VueRouter({
    routes: [
        {
            path: "/login",
            name: ROUTES.LOGIN,
            component: MediaGalleryLogin,
            meta: {requiredLogin: false, requiredTC: false}
        },
        {
            path: "/terms-and-conditions",
            name: ROUTES.TERMS_AND_CONDITIONS,
            component: MediaGalleryTermAndConditions,
            meta: {requiredLogin: true, requiredTC: false}
        },
        {
            path: "/media-search",
            name: ROUTES.SEARCH,
            component: MediaGallerySearchView,
            meta: {requiredLogin: true, requiredTC: true},
            beforeEnter: (to, from, next) => {
                router.app.$store.dispatch("setMode", MediaGalleryStateModeEnum.Search);
                if (router.app.$store.state.mediaGallery.reloadAssetsOnNavigation) {
                    router.app.$store.dispatch("searchAssets")
                }
                next()
            },
        },
        {
            path: "/collection",
            name: ROUTES.COLLECTION,
            component: MediaGalleryCollectionView,
            meta: {requiredLogin: true, requiredTC: true},
            beforeEnter: (to, from, next) => {
                router.app.$store.dispatch("setMode", MediaGalleryStateModeEnum.Collection);
                if (router.app.$store.state.mediaGallery.reloadCollectionAssetsOnNavigation) {
                    router.app.$store.dispatch("searchAssets")
                }
                next()
            }
        },
        {
            path: "/",
            redirect: {name: ROUTES.SEARCH}
        }
    ]
})

router.beforeEach((to, from, next) => {
    /*
    Check if route needs authenticated
    Check if route needs accepted terms and conditions
    Check if route is terms and conditions view and user has already accepted
     */
    if (to.meta?.requiredLogin && !router.app.$store.getters.isAuthenticated) {
        next({name: ROUTES.LOGIN})
    } else if (to.meta?.requiredTC && !router.app.$store.getters.hasAcceptedTerms) {
        next({name: ROUTES.TERMS_AND_CONDITIONS})
    } else if (to.name === ROUTES.TERMS_AND_CONDITIONS && router.app.$store.getters.hasAcceptedTerms) {
        next({name: ROUTES.SEARCH})
    } else {
        next()
    }
});

export default router;
